export const packages = {
  'Available Areas': 'Áreas Disponíveis',
  'Choose your areas!': 'Escolha suas áreas!',
  Contract: 'Contrato',
  'Minimum date for scheduling {{date}}':
    'Data mínima para o agendamento: {{date}}',
  Packages: 'Pacotes',
  'Remove all': 'Remover tudo',
  'Select all': 'Selecionar tudo',
  'Select an area to see the duration': 'Selecione uma área para ver a duração',
  'Select below which areas would you like to schedule':
    'Selecione abaixo quais áreas você deseja agendar.',
  'Select date': 'Selecionar horário',
  'Session duration {{duration}} minutes':
    'Duração da sessão: {{duration}} minutos',
  "You don't have areas to schedule yet":
    'Você ainda não tem áreas para agendar',
  'Your sessions of {{items}} can only be scheduled and performed in the unit they were adquired':
    'As suas sessões de {{items}} só podem ser agendadas e realizadas na unidade onde foram adquiridas',
};
